import React from 'react';

const TermsAndConditions = () => {
  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: 'auto', lineHeight: '1.6' }}>
      <h1>Terms & Conditions</h1>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using NeatnClean’s services, you agree to comply with these Terms & Conditions. If you do not agree, please refrain from using our services.
      </p>

      <h2>2. Services Offered</h2>
      <p>
        NeatnClean provides professional laundry and dry-cleaning services, including pickup and delivery. Service availability may vary depending on your location.
      </p>

      <h2>3. User Responsibilities</h2>
      <ul>
        <li><strong>Eligibility:</strong> Users must be at least 18 years old to use our services.</li>
        <li><strong>Accurate Information:</strong> You agree to provide true, accurate, and up-to-date information when registering or placing orders.</li>
        <li><strong>Compliance:</strong> You agree not to misuse our services or engage in any unlawful or disruptive activities.</li>
      </ul>

      <h2>4. Orders and Payments</h2>
      <ul>
        <li><strong>Booking:</strong> Orders can be placed through our website, mobile app, or customer support.</li>
        <li><strong>Pricing:</strong> All prices are listed on our platform and are subject to change without prior notice.</li>
        <li><strong>Payment:</strong> Payments must be made at the time of placing the order. We accept various methods including credit/debit cards, UPI, and net banking.</li>
      </ul>

      <h2>5. Cancellation and Refunds</h2>
      <ul>
        <li><strong>Cancellation:</strong> Orders may be canceled within a specified timeframe before the scheduled pickup. Contact our support team for assistance.</li>
        <li><strong>Refunds:</strong> Eligible refunds will be processed within <strong>[5–7 business days]</strong> to the original payment method.</li>
      </ul>

      <h2>6. Limitation of Liability</h2>
      <p>
        NeatnClean is not responsible for damage or loss of garments due to manufacturing defects, improper labeling, or items left in clothing. Liability, if any, is limited to the service charges paid.
      </p>

      <h2>7. Modifications</h2>
      <p>
        We reserve the right to modify these Terms & Conditions at any time. Continued use of our services implies acceptance of the updated terms.
      </p>
    </div>
  );
};

export default TermsAndConditions;
